module.exports = __webpack_public_path__ + "img/608-42dfb3.png";